import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'
import Vuei18n from 'vue-i18n'
import i18n from './lang'
import validationRules from './form-validations'
import Notifications from 'vue-notification'
import showNotifications from './plugins/notifications'
import forceFileDownload from './plugins/forceFileDownload'
import './plugins/formatCurrency'
import './plugins/axios'
import VueApexCharts from 'vue-apexcharts'

Vue.use(Vuei18n)
Vue.use(Notifications)
Vue.use(forceFileDownload)
Vue.use(showNotifications)
Vue.use(VueApexCharts)
Vue.component('apexchart', VueApexCharts)

import '@babel/polyfill'

Vue.config.productionTip = false

Object.defineProperty(Vue.prototype, '$validationRules', { value: validationRules })
Vue.prototype.$constants = require('./plugins/constants')

new Vue({
  router,
  i18n,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')